import { CustomRow } from "@/table/CustomTable";
import {
    Checkbox,
    Collapse,
    IconButton,
    TableCell,
    TableRow,
} from "@mui/material";
import { useRef, useState } from "react";
import AccountingBill from "./AccountingBill";
import { Subtitle } from "@/common/typography";
import DehazeRoundedIcon from "@mui/icons-material/DehazeRounded";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import { downloadFile, formattedCurrency } from "@/utils";
import { CheckAllBox } from "./AccountingBills";

export default function AccountingBillBatch({ batchData }) {
    const rowRef = useRef();
    const [batch, setBatch] = useState(batchData);
    const [expanded, setExpanded] = useState(false);
    const handleExpand = () => {
        setExpanded(!expanded);
    };
    const exportAch = (bank) => {
        const selectedBillIds = batch.accounting_bills.map((bill) => bill.id);
        if (selectedBillIds.length > 0) {
            downloadFile(`accounting-bills/ach-${bank}`, {
                ids: selectedBillIds,
            });
        }
    };
    const handleExport = () => {
        if (firstBillCurrency == "USD") {
            exportAch("td");
        } else {
            exportAch("rbc");
        }
    };
    const width = rowRef.current ? rowRef.current.offsetWidth * 0.97 : 0;

    return (
        <>
            <CustomRow ref={rowRef}>
                <TableCell width={50} align="left">
                    <span>
                        <CheckAllBox accountingBills={batch.accounting_bills} />
                    </span>
                </TableCell>
                <TableCell align="left" width={50}>
                    {batch.id}
                </TableCell>
                <TableCell align="left">{batch.name}</TableCell>
                <TableCell align="left">
                    {batch.paid_bills_count} / {batch.accounting_bills.length}
                </TableCell>
                <TableCell align="left">
                    {formattedCurrency(batch.total)}
                </TableCell>
                <TableCell align="right">
                    <IconButton onClick={handleExpand}>
                        <DehazeRoundedIcon />
                    </IconButton>
                    <IconButton onClick={handleExport}>
                        <FileDownloadOutlinedIcon />
                    </IconButton>
                </TableCell>
            </CustomRow>
            <TableRow>
                <TableCell
                    style={{ paddingBottom: 0, paddingTop: 0 }}
                    colSpan={12}
                >
                    <Collapse in={expanded} unmountOnExit>
                        <div style={{ width: width, overflow: "auto" }}>
                            <Subtitle>Bills</Subtitle>
                            {batch.accounting_bills.map((bill) => (
                                <AccountingBill
                                    key={bill.id}
                                    billData={bill}
                                    categories={[]}
                                    taxCodes={[]}
                                    isLine={false}
                                    hidden={false}
                                />
                            ))}
                        </div>
                    </Collapse>
                </TableCell>
            </TableRow>
        </>
    );
}
